import { Inspection } from '@/domain/Inspection'
import axios from 'axios'

/**
 * 検査項目サービス
 */
export default class InspectionsService {
    /** インスタンス */
    private static _instance: InspectionsService

    /**
     * コンストラクタ
     */
    // eslint-disable-next-line
    private constructor() {}

    /**
     * インスタンスの取得
     */
    public static get instance() {
        if (!this._instance) {
            this._instance = new InspectionsService();
        }
        return this._instance;
    }
    
    /**
     * 新規作成
     */
    public async createNew(): Promise<Inspection> {
        return await axios.get("/api/inspection/new")
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            // eslint-disable-next-line
            .catch((error) => {
                throw error
            })
    }
    
    /**
     * 編集
     */
    public async edit(no: string): Promise<Inspection> {
        return await axios.get(`/api/inspection/edit/${no}`)
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 新規保存
     */
    public async create(dto: Inspection): Promise<Inspection> {
        return await axios.post("/api/inspection/new", dto)
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 保存
     */
    public async update(dto: Inspection): Promise<Inspection> {
        return await axios.put(`/api/inspection/edit/${dto.code}`, dto)
            .then((results) => {
                if (results.status === 200) {
                    return this.convert(results.data)
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 検査項目一覧を検索
     */
    public async findAll(): Promise<Inspection[]> {
        return await axios.get("/api/inspections")
            .then((results) => {
                if (results.status === 200) {
                    return (results.data as Inspection[]).map(x => this.convert(x))
                } else {
                    throw results.statusText
                }
            })
            .catch((error) => {
                throw error
            })
    }

    /**
     * 受信データの変換
     * @param data
     */
    // eslint-disable-next-line
    private convert(data: any): Inspection {
        const inspection = data as Inspection
        return new Inspection({ ...inspection })
    }
}
